import * as React from "react";

const IconPaginationRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="currentColor">
            <polygon fill="currentColor" points="10 37 0 46 0 28" transform="translate(0 -28)" />
        </svg>
    );
};

export default React.memo(IconPaginationRight);
